import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** The one class-name joiner. Later classes win, Tailwind conflicts resolved by twMerge. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
